module.exports = __webpack_public_path__ + "static/media/dp-favicon-new.697b67ab.ico";